import React, { useEffect } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { Unauthorized, Toast } from '@plone/volto/components';
import { useDispatch, useSelector } from 'react-redux';
import { exportContents } from 'rer-theme/actions';
import { Container, Row, Col, Button, Spinner } from 'design-react-kit';
import { BodyClass, Helmet } from '@plone/volto/helpers';
import { Icon } from 'design-comuni-plone-theme/components/ItaliaTheme';
import { injectLazyLibs } from '@plone/volto/helpers/Loadable/Loadable';

const messages = defineMessages({
  exportContentsTitle: {
    id: 'exportContentsTitle',
    defaultMessage: 'Esporta contenuti',
  },
  exportContentsDescription: {
    id: 'exportContentsDescription',
    defaultMessage: 'Esporta tutti i contenuti del sito in un file csv.',
  },
  export_error_msg: {
    id: 'exportErrorLabel',
    defaultMessage: "Si è verificato un problema durante l'esportazione:",
  },
  export_error_generic_msg: {
    id: 'exportErrorGenericLabel',
    defaultMessage: "per favore contatta l'amministratore del sito.",
  },
  download: {
    id: 'downloadLabel',
    defaultMessage: 'Scarica',
  },
});

const ExportContentsView = ({ toastify }) => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const token = useSelector((state) => state.userSession.token);
  const exportState = useSelector((state) => state.exportContents);

  useEffect(() => {
    if (exportState.error) {
      const msg =
        exportState.error?.response?.body?.message ||
        intl.formatMessage(messages.export_error_generic_msg);
      const errorMsg = `${intl.formatMessage(
        messages.export_error_msg,
      )} ${msg}`;
      toastify.toast.error(<Toast error content={errorMsg} />);
    }
  }, [exportState]);

  if (!token) {
    return <Unauthorized />;
  }
  return (
    <div className="public-ui">
      <BodyClass className="public-ui" />
      <Container className="px-4 mt-4 export-contents-view">
        <Helmet title={intl.formatMessage(messages.exportContentsTitle)} />
        <Col xs="12" lg="10">
          {/* EXPORT TITLE */}
          <div className="heading py-3 pb-lg-4">
            <h1 className="heading-title">
              {intl.formatMessage(messages.exportContentsTitle)}
            </h1>
          </div>
        </Col>

        <Row className="mb-5">
          <p>{intl.formatMessage(messages.exportContentsDescription)}</p>
          <div>
            <Button
              className="fw-semibold btn-xs"
              color="primary"
              onClick={() => {
                dispatch(exportContents());
              }}
              title="prova"
            >
              {exportState.loading ? (
                <div className="export-spinner">
                  <Spinner active small={true} />
                </div>
              ) : (
                <Icon className="me-2" size="sm" icon="it-download" />
              )}
              {intl.formatMessage(messages.download)}{' '}
            </Button>
          </div>
        </Row>
      </Container>
    </div>
  );
};

ExportContentsView.propTypes = {};

export default injectLazyLibs(['toastify'])(ExportContentsView);
